import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select, Form } from 'ui/components';
import * as Fi from 'react-icons/fi';
import { ItemStock } from 'services/action';

const options = [
  {
    value: 'in',
    label: 'Stok Masuk',
  },
  {
    value: 'out',
    label: 'Stok Keluar',
  },
  {
    value: 'defect',
    label: 'Stok Rusak',
  },
];

const initialState = {
  items: [
    {
      item: null,
      item_id: null,
      quantity: null,
      type: null,
      _type: null,
    },
  ],
};

export const FormAdjusmentItems = ({ data, onInputChange }) => {
  const Dispatch = useDispatch();

  const StateForm = useSelector((state) => state?.Form);
  const StateWarehouse = useSelector((state) => state?.Auth?.warehouse);
  const [{ items }, setState] = React.useState(initialState);

  const $onLoadItemStock = async (i, e) => {
    const req = await Dispatch(
      ItemStock.$showByItemAndWarehouse(e?.id, StateWarehouse?.id)
    );

    let stock = 0;
    if (req !== undefined || req !== 'undefined') {
      stock = req?.stock_available;
    }

    let newItems = [...items];
    newItems[i]['stock'] = stock;

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  const $handleItemsChange = async (i, e, name) => {
    let newItems = [...items];
    if (e?.target?.name) {
      if (e?.target?.name === 'quantity') {
        newItems[i]['quantity'] = e.target.valueNumber;
      } else {
        newItems[i][e.target.name] = e.target.value;
      }
    } else if (name === 'tipe') {
      newItems[i]['_type'] = e;
      newItems[i]['type'] = e?.value;
    } else {
      newItems[i]['item_id'] = e?.id;
      newItems[i]['item'] = e;

      // get item stock with item_id and warehouse_id
      $onLoadItemStock(i, e);
    }

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  const $addMoreFields = async (i) => {
    setState((prevState) => ({
      ...prevState,
      items: [
        ...items,
        {
          item: null,
          item_id: null,
          quantity: null,
          type: null,
          _type: null,
        },
      ],
    }));
  };

  const $removeField = async (i) => {
    let newItems = [...items];
    let idx = newItems.indexOf(i);

    if (idx > -1) {
      newItems.splice(idx, 1);
    }

    return setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  React.useEffect(() => {
    const input = {
      items,
    };

    onInputChange(input);
  }, [items]);

  React.useEffect(() => {
    if (!data) return;

    let b = [];
    if (data) {
      data?.forEach((i) => {
        let type = {};
        if (i?.quantity_defect > 0) {
          type = options[2];
        } else if (i?.actual_quantity > i?.initial_quantity) {
          type = options[0]
        }else {
          type = options[1];
        }

        let qty = 0;
        if (type?.value === 'in') {
          qty = i?.actual_quantity - i?.initial_quantity;
        } else if (type?.value === 'out') {
          qty = i?.initial_quantity - i?.actual_quantity
        } else if (type?.value === 'defect') {
          qty = i?.defect_quantity;
        }

        b.push({
          item: i?.item,
          item_id: i?.item?.id,
          quantity: qty,
          _type: type,
          type: type?.value,
          stock: i?.initial_quantity,
        });
      });
    }
    setState((prevState) => ({ ...prevState, items: b }));
  }, [data]);

  React.useEffect(() => {
    if (data) return;

    setState({items: [
      {
        item: null,
        item_id: null,
        quantity: null,
        type: null,
        _type: null,
      },
    ]});
  }, [])

  return (
    <div className="mt-3">
      <div className="fw-semibold py-2 fs-6">Data Item</div>
      <div className="py-3">
        {items?.map((e, i) => (
          <div className={'row align-items-end border-bottom py-3 m-0'} key={i}>
            <div className="col-10">
              <div className="row">
                <>
                  <div className="col-md-4 ps-0">
                    <div className="mb-3">
                      <Select.Remote
                        label="Pilih Item"
                        required
                        placeholder=""
                        url="/wms/item"
                        initialValue={e?.item_id}
                        keys={e?.item_id}
                        params={{ is_active: 'active' }}
                        name="item_id"
                        row={(d) => {
                          return {
                            value: d?.id,
                            label: d?.alias_name,
                          };
                        }}
                        onSelected={(e) => $handleItemsChange(i, e)}
                        errors={
                          StateForm?.errors?.items ||
                          StateForm?.errors[`items.${i}.item_id`]
                        }
                      />
                    </div>
                  </div>

                  <div className="col-md-3 ps-0">
                    <div className="mb-3">
                      <div className="form-label required">Tipe</div>
                      <Select
                        isClearable
                        classNamePrefix={
                          StateForm?.errors[`items.${i}.type`]
                            ? 'is-invalid'
                            : 'select'
                        }
                        placeholder=""
                        options={options}
                        value={e?._type}
                        onChange={(e) => $handleItemsChange(i, e, 'tipe')}
                      />
                      {StateForm?.errors[`items.${i}.type`] && (
                        <div
                          className="invalid-feedback"
                          style={{ display: 'block' }}
                        >
                          {StateForm?.errors[`items.${i}.type`]}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-2 ps-0 ">
                    <Form.Input
                      autoComplete="off"
                      label="Stock Awal"
                      name="quantity"
                      type="text"
                      value={`${e?.stock || 0} ${e?.item?.default_fraction || ''}`}
                      error={
                        StateForm?.errors?.items ||
                        StateForm?.errors[`items.${i}.stock`]
                      }
                      disabled
                    />
                  </div>

                  <div className="col-md-2 ps-0 ">
                    <Form.Input
                      required
                      autoComplete="off"
                      label="Quantity"
                      name="quantity"
                      type="number"
                      value={e?.quantity}
                      onChange={(e) => $handleItemsChange(i, e)}
                      error={
                        StateForm?.errors?.items ||
                        StateForm?.errors[`items.${i}.quantity`]
                      }
                    />
                  </div>
                  <div className="col-md-1 ps-0 align-self-center ">
                    <div className='fw-semibold'>{e?.item?.default_fraction}</div>
                  </div>
                </>
              </div>
            </div>
            <div className="col-2 ">
              <button
                type="button"
                className="btn btn-danger rounded mb-3"
                style={{ minHeight: 36, minWidth: '100%' }}
                onClick={() => $removeField(e)}
                disabled={items?.length === 1}
              >
                <Fi.FiX />
              </button>
            </div>
          </div>
        ))}

        <div className="mt-3">
          <button
            type="button"
            className="btn btn-primary rounded mb-3"
            style={{ minHeight: 36, minWidth: '100%' }}
            onClick={() => $addMoreFields()}
          >
            <Fi.FiPlus className="me-2" /> Tambah Item
          </button>
        </div>
      </div>
    </div>
  );
};
